export default function Products() {
  const products = [
    {
      name: 'VPN',
      category: 'SECURITY',
      description: 'Secure and fast VPN service for iOS devices providing privacy protection and secure browsing',
      image: 'https://public.readdy.ai/ai/img_res/45a8eadb076a1dd84c2b02a8519d2286.jpg',
    },
    {
      name: 'Cleaner',
      category: 'OPTIMIZATION',
      description: 'Device optimization tool that helps users clean junk files, manage storage, and improve device performance',
      image: 'https://readdy.ai/api/search-image?query=modern%20iOS%20cleaner%20application%20interface%20showing%20storage%20management%20with%20circular%20progress%20indicators%2C%20clean%20white%20and%20green%20design%2C%20minimalist%20UI%20displaying%20file%20cleanup%20features%2C%20professional%20app%20screenshot%20with%20simple%20light%20background&width=380&height=520&seq=product-cleaner-app-002&orientation=portrait',
    },
    {
      name: 'More Coming',
      category: 'INNOVATION',
      description: 'We are constantly developing new innovative solutions to enhance your iOS experience',
      image: 'https://readdy.ai/api/search-image?query=abstract%20iOS%20app%20development%20concept%20with%20floating%20geometric%20shapes%2C%20gradient%20colors%20blue%20and%20purple%2C%20modern%20minimalist%20design%20showing%20innovation%20and%20technology%2C%20professional%20illustration%20with%20simple%20light%20background&width=380&height=520&seq=product-coming-soon-003&orientation=portrait',
    },
  ];

  return (
    <section id="products" className="py-32 bg-gray-50" data-product-shop>
      <div className="px-8 lg:px-24">
        <h2 className="text-6xl lg:text-7xl font-semibold text-center text-gray-900 mb-20">
          Our Products
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-80">
                <div className="absolute top-4 left-4 z-10">
                  <span className="inline-block px-3 py-1 bg-blue-500/15 text-blue-600 text-xs uppercase tracking-wider rounded-full font-medium">
                    {product.category}
                  </span>
                </div>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                  style={{ transform: 'perspective(1000px) rotateX(5deg)' }}
                />
              </div>
              <div className="bg-gray-900 p-8">
                <h3 className="text-3xl font-bold text-white mb-3">{product.name}</h3>
                <p className="text-base text-gray-400 leading-relaxed">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}